function clearStringAccents(string) {
  if (!string) return string;

  return string.normalize("NFD").replace(/\p{Diacritic}/gu, "");
}

export { clearStringAccents };
